/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["onClick"];
import dayjs from 'dayjs';
import { apiGlobalSynOrder } from '@/api/global'; // apiGlobalGetOrder
import CTable from '@ultra/share/components/CTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkQueryOrders } from '@/api/usdk';
import { useTaskStore } from '@/store/modules/downTask';
import OrderDetailDialog from './global/orderDetailDialog.vue';
import OrderRepairDialog from './global/orderRepairDialog.vue';
import SearchForm from './global/searchForm.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'globalOrderList',
  props: {
    gameInfo: {
      type: Object,
      required: true
    },
    tableKey: {
      type: String
    }
  },
  emits: ['onActive', 'onIOSMidst'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const filter = ref({});
    const columns = [{
      label: 'ID',
      prop: 'id',
      isForce: true,
      isDefault: true,
      slot: 'id'
    }, {
      label: '渠道订单号',
      prop: 'channelOrderNo',
      isDefault: true,
      slot: 'channelOrderNo'
    }, {
      label: '渠道',
      prop: 'cname',
      isDefault: true
    },
    // { label: '时区', prop: 'timezone', isDefault: true },
    {
      label: 'UltraSDKID',
      prop: 'uid',
      isDefault: true
    }, {
      label: '角色账号ID',
      prop: 'suid'
    }, {
      label: '产品名称',
      prop: 'productName'
    }, {
      label: '区服名称',
      prop: 'serverName',
      isDefault: true
    }, {
      label: '游戏角色ID',
      prop: 'roleId'
    }, {
      label: '角色名称',
      prop: 'roleName',
      isDefault: true
    }, {
      label: '设备号',
      prop: 'deviceId'
    }, {
      label: '下单时间',
      prop: 'createTime',
      isDefault: true,
      slot: 'createTime'
    }, {
      label: '支付方式',
      prop: 'payTypeName',
      isDefault: true
    }, {
      label: 'Ultra订单号',
      prop: 'hgOrderNo',
      isDefault: true
    }, {
      label: '第三方订单号',
      prop: 'thirdOrderNo',
      isDefault: true
    }, {
      label: '提交金额',
      prop: 'submitAmount'
    }, {
      label: '成交金额',
      prop: 'dealAmount',
      isDefault: true
    }, {
      label: '币种',
      prop: 'currency'
    }, {
      label: '道具名称',
      prop: 'goodsName'
    }, {
      label: '支付状态',
      prop: 'statusName',
      isDefault: true,
      slot: 'statusName'
    }, {
      label: '同步状态',
      prop: 'noticeStatusName',
      isDefault: true,
      slot: 'noticeStatusName'
    }, {
      label: '操作',
      prop: 'action',
      isForce: true,
      isDefault: true,
      slot: 'action'
    }];
    const orderDetailDialogRef = ref();
    const orderRepairDialogRef = ref();
    const createParams = () => {
      const params = JSON.parse(JSON.stringify(filter.value));
      for (const key in params) {
        if (params[key] === undefined || params[key] === '' || params[key] === null) {
          delete params[key];
        }
      }
      params.startDate = params.date ? dayjs(params.date[0]).format('YYYY-MM-DD') : '';
      params.endDate = params.date ? dayjs(params.date[1]).format('YYYY-MM-DD') : '';
      delete params.date;
      return params;
    };
    // 获取订单服务列表
    const getTableData = () => {
      const params = createParams();
      console.log({
        params
      });
      tableLoading.value = true;
      apiUsdkQueryOrders({
        area: 1,
        pageNum: current.value,
        pageSize: pageSize.value,
        gid: props.gameInfo.Id,
        q: JSON.stringify(params)
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data || [];
          total.value = res.total || 0;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const handleSearch = data => {
      filter.value = data;
      getTableData();
    };
    const repairOrder = (type, data) => {
      if (type === 'add') {
        orderRepairDialogRef.value.show({
          data
        });
      } else {
        ElMessageBox.confirm('是否确认同步？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiGlobalSynOrder({
            orderId: data.id,
            gid: data.gid
          }).then(res => {
            if (res.code === 0) {
              getTableData();
            }
          });
        }).catch(() => {
          console.log('取消');
        });
      }
    };
    const handleDetail = data => {
      orderDetailDialogRef.value.show({
        data
      });
    };
    const handleRepairOrder = (type, data) => {
      repairOrder(type, data);
    };
    const getReceiptTable = data => {
      emits('onActive', 'globalTicketVer', data);
    };
    const handleRepairLog = () => {
      emits('onActive', 'globalRepairLog');
    };
    const handleToIOSMidst = () => {
      emits('onIOSMidst', 'global');
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    const {
      setTask
    } = useTaskStore();
    const exportTable = () => {
      const params = createParams();
      // params.pageNum = current.value;
      // params.pageSize = pageSize.value;
      delete params.date;
      console.log('params', params);
      setTask({
        api: apiUsdkQueryOrders,
        page: 'pageNum',
        pageSize: 'pageSize',
        params: {
          gid: props.gameInfo.Id,
          area: 1,
          q: JSON.stringify(params)
        },
        data: 'data',
        total: 'total',
        excel: {
          title: `全球订单服务`,
          header: ['ID', '渠道', 'UltraSDKID', '角色账号ID', '产品名称', '区服名称', '游戏角色ID', '角色名称', '设备号', '下单时间', '支付方式', 'Ultra订单号', '第三方订单号', '提交金额', '成交金额', '币种', '道具名称', '支付状态', '同步状态'],
          field: ['id', 'cname', 'uid', 'suid', 'productName', 'serverName', 'roleId', 'roleName', 'deviceId', 'createTime', 'payTypeName', 'hgOrderNo', 'thirdOrderNo', 'submitAmount', 'dealAmount', 'currency', 'goodsName', 'statusName', 'noticeStatusName']
        }
      });
    };
    watch(() => props.gameInfo, val => {
      if (val && val.Id) {
        filter.value.gid = val.Id;
        getTableData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(SearchForm, {
        gid: __props.gameInfo.Id,
        onSearch: handleSearch
      }, null, 8, ["gid"]), _createVNode(CTable, {
        "current-page": _unref(current),
        loading: _unref(tableLoading),
        "page-size": _unref(pageSize),
        "table-columns": columns,
        "table-data": _unref(tableData),
        total: _unref(total),
        pagination: "",
        onSizeChange: _unref(handleSizeChange),
        onCurrentChange: _unref(handleCurrentChange)
      }, {
        top: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleToIOSMidst
        }, {
          default: _withCtx(() => [_createTextVNode("IOS玩家小票补单")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleRepairLog
        }, {
          default: _withCtx(() => [_createTextVNode("补单日志")]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "marginL10",
          type: "primary",
          onClick: exportTable
        }, {
          default: _withCtx(() => [_createTextVNode("导出数据")]),
          _: 1
        })]),
        id: _withCtx(({
          scope
        }) => [_createElementVNode("a", {
          href: "javascript:;",
          onClick: $event => handleDetail(scope.row)
        }, _toDisplayString(scope.row.id), 9, _hoisted_1)]),
        statusName: _withCtx(({
          scope
        }) => [_createElementVNode("div", {
          style: _normalizeStyle({
            color: scope.row.status === 0 ? '#52c41a' : '#f5222d'
          })
        }, _toDisplayString(scope.row.statusName), 5)]),
        noticeStatusName: _withCtx(({
          scope
        }) => [_createElementVNode("div", {
          style: _normalizeStyle({
            color: scope.row.noticeStatus === 0 ? '#52c41a' : '#f5222d'
          })
        }, _toDisplayString(scope.row.noticeStatusName), 5)]),
        channelOrderNo: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(scope.row.id) + _toDisplayString(scope.row.hgOrderNo), 1)]),
        createTime: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(scope.row.createTime), 1)]),
        action: _withCtx(({
          scope
        }) => [scope.row.status !== 0 && [1, 2, 11, 12, 13, 14].includes(scope.row.payType) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          disabled: scope.row.status === 0 && scope.row.noticeStatus === 0,
          link: "",
          size: "small",
          type: "primary",
          onClick: $event => repairOrder('add', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("补单")]),
          _: 2
        }, 1032, ["disabled", "onClick"])) : _createCommentVNode("", true), scope.row.status === 0 && scope.row.noticeStatus !== 0 && scope.row.noticeStatus !== 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          disabled: scope.row.status === 0 && scope.row.noticeStatus === 0,
          link: "",
          size: "small",
          type: "primary",
          onClick: $event => repairOrder('sync', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("同步")]),
          _: 2
        }, 1032, ["disabled", "onClick"])) : _createCommentVNode("", true), scope.row.payType == 1 && scope.row.status !== 0 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          disabled: scope.row.status === 0 && scope.row.noticeStatus === 0,
          link: "",
          size: "small",
          type: "primary",
          onClick: $event => getReceiptTable(scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("小票查询")]),
          _: 2
        }, 1032, ["disabled", "onClick"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["current-page", "loading", "page-size", "table-data", "total", "onSizeChange", "onCurrentChange"]), _createVNode(OrderRepairDialog, {
        ref_key: "orderRepairDialogRef",
        ref: orderRepairDialogRef,
        gid: __props.gameInfo.Id,
        onSuccess: getTableData
      }, null, 8, ["gid"]), _createVNode(OrderDetailDialog, {
        ref_key: "orderDetailDialogRef",
        ref: orderDetailDialogRef,
        onRepairOrder: handleRepairOrder
      }, null, 512)], 64);
    };
  }
});